import {RequiredFile} from "./required-file";
import {DTO} from "../../../../common/utils/types";
import {HandleUploadFunctionType} from "../common/types";

export class RequiredUploads {
    requiredFiles: Array<RequiredFile>

    constructor(requiredFiles: Array<DTO<RequiredFile>>) {
        this.requiredFiles = requiredFiles.map((requiredFile: DTO<RequiredFile>) => new RequiredFile(requiredFile))
    }

    areMandatoryFilesUploaded(uploadedFilesIds: Array<string>): boolean {
        return this.mandatoryFileIds().filter(
            (mandatoryFileId) =>
                !uploadedFilesIds.some((uploadedFileId: string) => uploadedFileId === mandatoryFileId)
        ).length === 0;
    }

    private mandatoryFileIds(): Array<string> {
        return this.requiredFiles.filter(
            (requiredFile: RequiredFile) => requiredFile.isMandatory
        ).map((requiredFile: RequiredFile) => requiredFile.id)
    }

    render(handleUpload: HandleUploadFunctionType) {
        return (
            <>
                {
                    this.requiredFiles.length === 0 ? <>No Files required for upload</> :
                        this.requiredFiles.map((requiredFile: RequiredFile) => {
                            return (
                                <div key={requiredFile.id}>
                                    {requiredFile.render(handleUpload)}
                                </div>
                            )
                        })
                }
            </>
        )
    }
}